var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4283 1.11186L10.4287 1.1115C10.5584 0.981758 10.7668 0.981758 10.8965 1.1115C11.0179 1.2329 11.0179 1.44965 10.8965 1.57106L6.82154 5.64606L6.46799 5.99961L6.82154 6.35316L10.8965 10.4282C11.0263 10.5579 11.0263 10.7663 10.8965 10.8961C10.7668 11.0258 10.5584 11.0258 10.4287 10.8961L6.35365 6.82106L6.0001 6.4675L5.64654 6.82106L1.57154 10.8961C1.44181 11.0258 1.23339 11.0258 1.10365 10.8961C0.973913 10.7663 0.973913 10.5579 1.10365 10.4282L5.17865 6.35316L5.53221 5.99961L5.17865 5.64606L1.10365 1.57106C0.973913 1.44132 0.973913 1.2329 1.10365 1.10316C1.23339 0.973425 1.44181 0.973425 1.57154 1.10316L5.64654 5.17816L5.99974 5.53135L6.35329 5.17852L10.4283 1.11186Z",
    fill: "#2B8C34",
    stroke: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.9d44000eee83ae6082bcc2c3676e2a26.svg";
export { ForwardRef as ReactComponent };